import React, { Component } from 'react';
import Well from '$components/ProductDashboard/Well';
import ContentProgress from '$components/ProductDashboard/ContentProgress';
import MemoryProgress from '$components/ProductDashboard/MemoryProgress';
import styles from './styles.scss';

class Progress extends Component {
  render() {
    const { flatContent, inflatedContent, product } = this.props;

    return (
      <div className={styles.background}>
        <Well>
          <div className={styles.layout}>
            <div className={styles.progressBlock}>
              <ContentProgress
                flatContent={flatContent}
                inflatedContent={inflatedContent}
                product={product}
              />
            </div>
            <div className={styles.progressBlock}>
              <MemoryProgress inflatedContent={inflatedContent} product={product} />
            </div>
          </div>
        </Well>
      </div>
    );
  }
}

export default Progress;
